module.exports = __webpack_public_path__ + "img/example3.c4b96495.png";